<!--
Shows a component with 3 buttons:
[Submit/Save][Cancel]  [Remove]

Properties:

id: (Optional) For creating a unique id for multiple instances of same component.

isBtnSaveDisabled: true => Save button is disabled.
    false => Save button is enabled.

iSaving: true => all buttons are disabled, Save button shows an animation.
    false => all buttons are available.

isDeleting: true => all buttons are disabled, Remove button shows an animation.
    false => all buttons are available.

mode: MODE_EDIT => button Remove is visible.
      MODE_ADD => button Remove is invisible.

Events:
    cancel: click Cancel button
    remove: click Remove button
-->

<template>
    <div class="sticky-bottom fixed-bottom">
        <div class="btn-group">
            <b-button
                type="submit"
                :id="`save_button${id}`"
                variant="primary"
                class="d-flex align-items-center"
                :disabled="inProgress || isDisabled || isBtnSaveDisabled"
            >
                {{ $t(saveLabel) }}&nbsp;<span
                    class="fas"
                    v-bind:class="{
                        'fa-check': !isSaving,
                        'fa-sync-alt fa-spin': isSaving
                    }"
                ></span>
            </b-button>
            <b-button
                v-if="showCopyButton && mode === modeEditConst"
                @click="onCopy"
                :id="`copy_button${id}`"
                class="btn-space-5"
                :disabled="inProgress || isDisabled"
            >
                {{ $t('btnCopyLabel') }}&nbsp; <span class="fa fa-copy"></span>
            </b-button>
            <b-button
                :id="`cancel_button${id}`"
                @click="onCancel"
                class="d-flex align-items-center btn-space-5"
                :disabled="inProgress"
            >
                {{ $t('btnCancelLabel') }}&nbsp;<span
                    class="fas fa-times"
                ></span>
            </b-button>
        </div>
        <div
            class="btn-group"
            v-show="mode === modeEditConst && !hideDeleteButton"
        >
            <b-button
                :id="`remove_button${id}`"
                @click="onRemove"
                class="d-flex align-items-center btn-space-10"
                :disabled="inProgress || isDisabled || isBtnRemoveDisabled"
            >
                {{ $t('btnDeleteLabel') }}&nbsp;<span
                    class="far"
                    v-bind:class="{
                        'fa-trash-alt': !isDeleting,
                        'fa-sync-alt fa-spin': isDeleting
                    }"
                ></span>
            </b-button>
        </div>
    </div>
</template>

<script>
    import { MODE_EDIT } from '../constants';

    export default {
        name: 'SubmitCancelRemove',
        // This component should have properties to directly show/hide individual buttons
        // not derive button state from "mode" or other indirect ways of determining button state.
        // It is up to the calling component to request button visibility
        props: {
            id: { type: String, required: false, default: '' },
            saveLabel: { type: String, required: false, default: 'btnSaveLabel' },
            isSaving: { type: Boolean, default: false },
            isDeleting: { type: Boolean, default: false },
            isDisabled: { type: Boolean, default: false },
            isBtnSaveDisabled: { type: Boolean, default: false },
            isBtnRemoveDisabled: { type: Boolean, default: false },
            mode: { type: Number, default: 0 },
            showCopyButton: { type: Boolean, default: false },
            hideDeleteButton: { type: Boolean, default: false }
        },

        data: function () {
            return {
                // Constants
                modeEditConst: MODE_EDIT
            };
        },

        computed: {
            inProgress() {
                return this.isSaving || this.isDeleting;
            }
        },

        methods: {
            onCancel() {
                this.$emit('cancel', null);
            },

            onRemove() {
                this.$emit('remove', null);
            },

            onCopy() {
                this.$emit('copy', null);
            }
        }
    };
</script>
